import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import OrganisationLayout from "../layout/OrganisationLayout";

export default function OrganisationGroupsHelpAndSupport() {
  return (
    <OrganisationLayout>
      <Container fluid>
        <Row className="justify-content-center">
          <Col xxl={5} xl={5} lg={6} className="mt-4">
            <div className="cmn-card-color mt-4 pb-4 pt-4">
              <div className="back-page-title">
                <Link to="/organisations/settings">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M13.75 5.5L8.25 11L13.75 16.5"
                      stroke="#CCD2E3"
                      strokeWidth="2"
                    />
                  </svg>
                </Link>
              </div>
              <div className="student-view">
                <h2>Help &amp; Support</h2>
                <p>We&apos;re here to help.</p>
                <p>
                  From this page, you can read answers to frequently asked questions
                  or report an issue you&apos;re having with Peerscroller.
                </p>
                <p>
                  We&apos;re also available via{" "}
                  <a href="mailto:help@peerscroller.com">help@peerscroller.com</a>,
                  so don&apos;t be afraid to reach out if you&apos;re having any trouble.
                </p>

                <Link to="/organisations/faqs" className="cmn-pink w-50 mb-3 mt-4">
                  FAQs
                </Link>
                <Link to="/organisations/report-issue" className="cmn-pink w-50 mb-3">
                  Report an Issue
                </Link>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://forms.yipiyap.co.uk/videoidea"
                  className="cmn-pink w-50 mb-3"
                >
                  Request a Video
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </OrganisationLayout>
  );
}
